module.exports = __webpack_public_path__ + "static/media/dashboard.009696f2.svg";